import React, { useEffect, useState } from 'react';
import '../Count/Count.css';
import { FaUserFriends, FaCampground, FaHeadset } from 'react-icons/fa';
import { MdThumbUp } from 'react-icons/md';

const Count = () => {
  const [count, setCount] = useState({
    travelers: 0,
    tents: 0,
    satisfaction: 0,
    years: 0
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => ({
        travelers: prev.travelers < 30.3 ? +(prev.travelers + 0.3).toFixed(1) : 30.3,
        tents: prev.tents < 40.5 ? +(prev.tents + 0.5).toFixed(1) : 40.5,
        satisfaction: prev.satisfaction < 88.9 ? +(prev.satisfaction + 1).toFixed(1) : 88.9,
        years: prev.years < 6.3 ? +(prev.years + 0.2).toFixed(1) : 6.3
      }));
    }, 40);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="count-section">
      <div className="count-container">
        <div className="count-box">
          <div className="icon-circle orange animate-bounce"><FaUserFriends /></div>
          <h2>{count.travelers}k</h2>
          <p>Happy Traveler</p>
        </div>
        <div className="count-box">
          <div className="icon-circle orange animate-bounce"><FaCampground /></div>
          <h2>{count.tents}k</h2>
          <p>Tent Sites</p>
        </div>
        <div className="count-box">
          <div className="icon-circle blue animate-bounce"><MdThumbUp /></div>
          <h2>{count.satisfaction}%</h2>
          <p>Satisfaction Rate</p>
        </div>
        <div className="count-box">
          <div className="icon-circle orange animate-bounce"><FaHeadset /></div>
          <h2>{count.years}+</h2>
          <p>Year Of Service</p>
        </div>
      </div>
    </section>
  );
};

export default Count;
